import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { Button, primarySmallTheme } from '@repo/ui/components/Buttons';
import { fireToast } from '@repo/ui/components/Toast';
import { P2, P3 } from '@repo/ui/components/Typography';
import { buildWebsiteUrl } from '@repo/utils/url';

import InviteShareEmailButton from 'components/Subscription/Invites/InviteShareEmailButton';
import InviteShareWhatsappButton from 'components/Subscription/Invites/InviteShareWhatsappButton';
import {
  CopyLinkButton,
  CopyLinkButtonMobileWrapper,
  LinkButtonsWrapper,
  LinkCopyWrapper,
} from 'components/Subscription/Invites/styles';
import { InviteLinkActionsProps } from 'components/Subscription/Invites/types';
import { HideMobile } from 'styles/queries';

const InviteLinkActions: React.FC<InviteLinkActionsProps> = (props) => {
  const inviteLink = buildWebsiteUrl(`/invite/${props.slug}`);

  const handleCopyLinkClick = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(inviteLink);

      fireToast({ label: 'Link copied to clipboard' });

      props.onCopyLinkClick?.();
    } catch (e) {
      fireToast({ label: `Failed to copy invite link: ${e}` });
    }
  };

  return (
    <LinkCopyWrapper>
      <CopyLinkButton onClick={handleCopyLinkClick}>
        <P2 className="link" color="#3C67C4">
          {inviteLink}
        </P2>
        <HideMobile mobileBreakpoint="tabletAndUp">
          <P3 style={{ textDecoration: 'underline', whiteSpace: 'nowrap' }}>
            Copy Link
          </P3>
        </HideMobile>
      </CopyLinkButton>
      <LinkButtonsWrapper>
        <CopyLinkButtonMobileWrapper style={{ width: '100%' }}>
          <Button
            label="Copy Link"
            name="copyInviteLinkButton"
            theme={primarySmallTheme}
            width="100%"
            onClick={handleCopyLinkClick}
          />
        </CopyLinkButtonMobileWrapper>
        <InviteShareWhatsappButton
          inviteLink={inviteLink}
          onClick={props.onWhatsappShareClick}
        />
        <InviteShareEmailButton
          inviteLink={inviteLink}
          mailBody={props.mailBody}
          mailSubject={props.mailSubject}
          onClick={props.onEmailShareClick}
        />
      </LinkButtonsWrapper>
    </LinkCopyWrapper>
  );
};

export default withEventScope(InviteLinkActions, {
  module: 'inviteLinkActions',
});
